import React from 'react';
import propTypes from './propTypes';

const Spray = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M10.4998 12H13.4998L14.8769 15.6467C15.1239 16.3008 14.6406 17 13.9414 17H10.0593C9.3602 17 8.87686 16.301 9.12367 15.647L10.4998 12ZM11.4998 14L10.9998 15H12.9998L12.4998 14H11.4998Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10.9998 23L10.9998 19H12.9998L12.9998 23H10.9998Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.8319 21.0508L14.1678 18.5547L15.8319 17.4453L17.496 19.9414L15.8319 21.0508Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M6.50369 19.9415L8.16779 17.4453L9.83189 18.5547L8.16779 21.0509L6.50369 19.9415Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.18915 3.58212C4.71538 2.92036 5.18838 2 6.00225 2H17.9971C18.811 2 19.284 2.92034 18.8102 3.5821L13.4998 11H10.4998L5.18915 3.58212ZM7.94284 4L11.5143 9H12.485L16.0565 4H7.94284Z" fill="currentColor" />
  </svg>
);

Spray.propTypes = propTypes;

export default Spray;
